import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const IframeWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 750px;
  border: none;
`;

const Relatorio = () => {
  return (
    <Wrapper>
      <IframeWrapper>
        <StyledIframe
          title="MyLegal Writer"
          src="https://app.fabric.microsoft.com/reportEmbed?reportId=e462fb0b-72cb-4922-80e4-8711396dec81&amp;autoAuth=true&amp;ctid=71e5e26e-8bbf-403a-9c28-cc2f7b036cdf"
          allowFullScreen
        />
      </IframeWrapper>
    </Wrapper>
  );
};

export default Relatorio;
